import React from 'react'

const ProblemsLocked = () => (
  <p style={{ fontFamily: "Source Sans Pro", fontSize: "1.2em", margin: 30, textAlign: "center" }}>You have ran out of daily problems!<br/>Upgrade to Plus Tier for unlimited problem and more!</p>
)

export default ProblemsLocked